import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const Row = ({name, value}) => {
    return (
        <TableRow>
            <TableCell className="highlight">{name}</TableCell>
            <TableCell>{value}</TableCell>
        </TableRow>
    );
};

const Component = (props) => {
    const getValue = () => (props.fmtValue) ? props.fmtValue : props.value;

    if (props.checkNull) {
        return (
            <>
                {(props.value !== null)
                    ? <Row name={props.name} value={getValue()}/>
                    : null
                }
            </>
        );
    }
    else {
        return (
            <Row name={props.name} value={props.value}/>
        );
    }
};

Component.propTypes = {
    checkNull: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    fmtValue: PropTypes.string,
};

Component.defaultProps = {
    checkNull: false,
};

export default Component;
